export const Hamburger = (props: any) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="21"
      height="13"
      fill="none"
      viewBox="0 0 21 13"
      {...props}
    >
      <path stroke="currentColor" strokeWidth="2" d="M0 1.478L21 1.478"></path>
      <path
        stroke="currentColor"
        strokeWidth="2"
        d="M0 11.521L21 11.521"
      ></path>
    </svg>
  );
};
